import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iWorkFlowStopState{
    response: any;
    isLoading: boolean;
    message: string | null;
} 
const initialState: iWorkFlowStopState = {
    response: null,
    isLoading: false,
    message: "",
};
export const workFlowStopAPI = createAsyncThunk(
    "workFlowStopAPI",
    async (data: {
        workflow_id: string;
    }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/workflow/stop/';
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                workflow_id: data.workflow_id
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const workFlowStopSlice = createSlice({
    name: "workFlowStop",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(workFlowStopAPI.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(workFlowStopAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(workFlowStopAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    }
});

export default workFlowStopSlice.reducer;